import axios from '../../utils/axios';
import i18n from '../../i18n';
import { BAD_REQUEST, INTERNAL_SERVER_ERROR, OK } from '../../utils/const/http';

const postLogin = async ({
  email, password, ipAddress, userAgentFull, userAgentShort,
}) => {
  try {
    const response = await axios.post('/api/auth/login', {
      email,
      password,
      ipAddress,
      userAgentFull,
      userAgentShort,
    });

    return {
      success: true,
      status: OK.status,
      message: OK.message,
      data: response.data,
    };
  } catch (err) {
    const { response } = err;
    const { status = INTERNAL_SERVER_ERROR.status } = response || {};
    let { message } = INTERNAL_SERVER_ERROR;

    if (status === 429) {
      message = i18n.t('login.errors.tooManyAttempts');
    } else if (status === 400) {
      message = i18n.t('login.errors.invalidCredentials');
    } else if (response) {
      const { data } = response;
      message = data.data.errorMessage;
    }
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: message,
      },
    };
  }
};

const postRegister = async ({
  fullName, dni, countryCode, email, password, role, phoneNumber,
  numberAccount, qrAuthorization, avatar, lastName, bank,
}) => {
  try {
    const response = await axios.post('/api/auth/register', {
      fullName,
      dni,
      countryCode,
      email,
      password,
      role,
      phoneNumber,
      numberAccount,
      qrAuthorization,
      avatar,
      lastName,
      bank,
    });

    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

// RECOVER PASSWORD
const postRecoverPassword = async (email) => {
  try {
    const response = await axios.post('/api/auth/recover-password', {
      email,
    });

    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

// RESET PASSWORD
const updatePassword = async ({ token, password, confirmPassword }) => {
  try {
    const response = await axios.post('/api/auth/reset-password', {
      token,
      password,
      confirmPassword,
    });

    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

// USER VERIFICATION
const userVerification = async ({ token, password, confirmPassword }) => {
  try {
    const response = await axios.post('/api/auth/user-verification', {
      token,
      password,
      confirmPassword,
    });

    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const refreshToken = async (config = {}) => {
  try {
    const response = await axios.get('/api/auth/refresh-token', config);

    return {
      success: true,
      status: OK.status,
      message: OK.message,
      data: response.data.data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {},
    };
  }
};

const verifyToken = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.post('/api/auth/verify-token', { token });
    return {
      success: true,
      status: OK.status,
      message: OK.message,
      data: response.data,
    };
  } catch (err) {
    return {
      success: false,
      status: err.response ? err.response.status : INTERNAL_SERVER_ERROR.status,
      message: INTERNAL_SERVER_ERROR.message,
      data: {},
    };
  }
};

export {
  postLogin,
  postRegister,
  postRecoverPassword,
  updatePassword,
  userVerification,
  refreshToken,
  verifyToken,
};
